import { name } from "./block.json";

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
	const swiperHTMLElement = block.querySelector<HTMLElement>('.swiper');

	if (!swiperHTMLElement) {
		return;
	}

	const nextEl = block.querySelector<HTMLElement>('.swiper-button-next');
	const prevEl = block.querySelector<HTMLElement>('.swiper-button-prev');

	// swiper-button-disabled

	const swiper = new Swiper(swiperHTMLElement, {
		speed: 250,
		loop: false,
		breakpointsBase: 'container',
		touchEventsTarget: 'container',
		spaceBetween: 0,
		slidesPerView: 1.1,
		breakpoints: {
			480: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},
			992: {
				slidesPerView: 4,
			}
		},

		modules: [Navigation],
		navigation: {
			nextEl,
			prevEl,
		},
	});
}
